import PropTypes from 'prop-types'
import React from 'react'
import './header.scss'

const Header = () => (
  <div className="header">
    <div className="header-content-wrapper">
      <div id="header-title-container"></div>    
      <div id="header-sublink-wrapper" />
    </div>
  </div>
)

Header.propTypes = {
  siteTitle: PropTypes.string,
}

Header.defaultProps = {
  siteTitle: ``,
}

export default Header
